import { getImageUrl } from "../api/utils";
import { shuffleArray, stripEmojis } from "../utils";

import StarRating from "./StarRating";
const FALLBACK_IMAGE = "/assets/images/product-placeholder.svg";

const ProductCard = ({
  product,
  perRowClass = "col-lg-3",
  setResponsiveGrid = true,
  showWhiteText = false,
}) => {
  const { slug, display_image, name, price, compare_price, avg_rating } =
    product;

  const images = (
    (product.variant_images || []).filter((i) => i.show_as_display_image)
      .length > 0
      ? (product.variant_images || []).filter((i) => i.show_as_display_image)
      : shuffleArray(product.variant_images || [])
  ).slice(0, 2);
  const image = getImageUrl(images?.[0]?.image) || FALLBACK_IMAGE;
  const hoverImage =
    images?.length > 1
      ? getImageUrl(images?.[1]?.image)
      : getImageUrl(images?.[0]?.image) || FALLBACK_IMAGE;

  const numericPrice = Number(price);
  const numericComparePrice = Number(compare_price);
  const onSale =
    !Number.isNaN(numericPrice) &&
    !Number.isNaN(numericComparePrice) &&
    numericComparePrice > numericPrice;
  const formatPrice = (value) => {
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
      return value;
    }
    return numericValue.toString();
  };

  const discount =
    numericComparePrice > 0 && !Number.isNaN(numericPrice)
      ? Math.round((1 - numericPrice / numericComparePrice) * 100)
      : 0;

  return (
    <div
      className={`card-product ${setResponsiveGrid ? `${perRowClass} col-md-6 col-sm-6 col-6` : ""} mt-4 mb-4`}
    >
      <div
        className="card-product-wrapper"
        style={{ border: "1px solid #f4f4f4" }}
      >
        <a
          href={`/products/${product.slug || product.product_slug}`}
          className="product-img"
        >
          <img
            loading="lazy"
            decoding="async"
            className="lazyload img-product"
            src={image}
            alt={name}
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = FALLBACK_IMAGE;
            }}
          />
          <img
            loading="lazy"
            decoding="async"
            className="lazyload img-hover"
            src={hoverImage}
            alt={name}
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = FALLBACK_IMAGE;
            }}
          />
        </a>

        {/* Sale badge */}
        {onSale && (
          <div className="on-sale-wrap text-end">
            <div
              className="on-sale-item"
              style={{ backgroundColor: "#3a00ac" }}
            >
              -{discount}%
            </div>
          </div>
        )}
      </div>
      <div className="card-product-info">
        <a
          href={`/products/${product.slug}`}
          className="title link"
          style={{
            color: showWhiteText ? "#fff" : "inherit",
            fontWeight: "600",
          }}
        >
          {stripEmojis(product.name)}
        </a>
        <span
          className="price current-price"
          style={{
            color: showWhiteText ? "#fff" : "inherit",
          }}
        >
          Starting from ₹{Number(product.price).toLocaleString("en-IN")}
          {product.compare_price > product.price && (
            <span
              className="compare-at-price"
              style={{
                marginLeft: 8,
                fontSize: 12,
                color: "#aaa",
                textDecoration: "line-through",
              }}
            >
              ₹{Number(product.compare_price).toLocaleString("en-IN")}
            </span>
          )}
        </span>
        <StarRating
          rating={Number(product.avg_rating ?? 0)}
          count={product.reviews_count ?? 0}
        />
      </div>
    </div>
  );
};

export default ProductCard;
